import script from "./SaveBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveBtn.vue?vue&type=script&setup=true&lang=js"

import "./SaveBtn.vue?vue&type=style&index=0&id=2f03cd9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f03cd9c"]])

export default __exports__